import React from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import styles from "./CommonSelectMultiple.module.css";

/**
 * Input reutilizável para seleção de múltiplas opções
 */
function CommonSelectMultiple({
  label,
  id,
  value,
  onChange,
  data,
  optionLabel,
  renderOptionLabel = null,
  placeholder = null,
  required = false,
  disabled = false,
  labelStyle = {},
  groupBy = null,
  ...props
}) {
  const getLabel = (option) =>
    renderOptionLabel ? renderOptionLabel(option) : option[optionLabel] ?? "";

  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label} style={labelStyle}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <Autocomplete
        multiple
        name={id}
        id={id}
        onChange={disabled ? null : onChange}
        groupBy={groupBy ? (option) => option[groupBy] : null}
        options={data}
        value={value}
        getOptionLabel={getLabel} // Use getLabel for selected values and input
        filterSelectedOptions
        size="small"
        renderOption={(props, option) => (
          <li {...props} style={{ fontSize: "15px" }}>
            {getLabel(option)} {/* Use getLabel for dropdown options */}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            sx={{
              "& fieldset": {
                borderColor: "#CED4DA !important",
                borderWidth: "1px !important",
                boxShadow: "none",
              },
              "&:hover:not(.Mui-disabled) fieldset": {
                borderColor: "#CED4DA !important",
                borderWidth: "1px !important",
                boxShadow: "none",
              },
              "&:focus:not(.Mui-disabled) fieldset": {
                borderColor: "#CED4DA !important",
                borderWidth: "1px !important",
                boxShadow: "none",
              },
            }}
          />
        )}
        disabled={disabled}
        {...props}
      />
    </>
  );
}

CommonSelectMultiple.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.any).isRequired, // Adjusted to handle objects
  onChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  optionLabel: PropTypes.string.isRequired,
  renderOptionLabel: PropTypes.func, // New prop for custom label rendering
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  labelStyle: PropTypes.object,
  groupBy: PropTypes.string,
};

export default CommonSelectMultiple;
